import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import SystemConfig from "../../system/SystemConfig";
import IUIActions from "../IUIActions";
import DesktopDOM from "./DesktopDOM";
import IApp from "../../engine/IApp";
import AbstractUI from "../AbstractUI";
import DesktopUIScreen from "./DesktopUIScreen";
import AudioController from "../AudioController";

@injectable()
export default class DesktopUI extends AbstractUI {

    public dom: DesktopDOM;

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.EngineApp) app: IApp,
        @inject(SERVICE_IDENTIFIER.DOM) dom: DesktopDOM,
        @inject(SERVICE_IDENTIFIER.UIActions) uiActions: IUIActions,
        @inject(SERVICE_IDENTIFIER.UIScreen) uiScreen: DesktopUIScreen,
        @inject(SERVICE_IDENTIFIER.AudioController) audioController: AudioController
    ) {
        super(config, dom, uiActions, uiScreen, audioController);
        this.dom = dom;
    }

    create() {
        super.create();
        $("#wrapper").addClass("device-desktop");
    }
}